export const FormSectionWrapper = ({ title, children }) => {
    return (
        <div className='form-section'>
            <h5>{title}</h5>
            {children}
        </div>
    )
}
